import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpTimelineContextualMenuComponent from './adpTimelineContextualMenu.component';

let adpTimelineContextualMenuModule = angular.module('adpTimelineContextualMenu', [
  uiRouter
])

.component('adpTimelineContextualMenu', adpTimelineContextualMenuComponent)

.name;

export default adpTimelineContextualMenuModule;



// WEBPACK FOOTER //
// ./src/app/components/adpTimelineContextualMenu/adpTimelineContextualMenu.js